import {
  Badge,
  Box,
  Divider,
  Flex,
  Heading,
  Icon,
  Text,
  VStack
} from "@chakra-ui/react";
import { FaCreditCard } from "react-icons/fa";
import { BsCheckCircle } from "react-icons/bs";
import { useApplicationContext } from "contexts/ApplicationContext";
import { isColomboUser } from "utils/is-colombo-user";

export function UpdateChangesContent() {
  const { user } = useApplicationContext();
  const isColombo = isColomboUser(user);
  return (
    <>
      <Flex alignItems="center" gap={3} mb={2}>
        <Box
          fontSize={{ base: "1.5rem", "2xl": "1.875rem" }}
          fontWeight="semibold"
          lineHeight="1.2"
          color="gray.800"
        >
          Alterações do PowerHub
        </Box>
        <Badge colorScheme="blue" borderRadius="full" px={3} py={1}>
          Atualização
        </Badge>
      </Flex>
      <Text color="gray.600" mb={8} fontWeight="medium">
        Vigência a partir de 02/03/2026
      </Text>

      {!isColombo && (
        <Box
          bg="#F0F6FF"
          p={6}
          borderRadius="xl"
          border="1px solid"
          borderColor="blue.200"
          mb={8}
        >
          <Flex align="center" gap={4} mb={6}>
            <Flex
              align="center"
              justify="center"
              bg="white"
              w={12}
              h={12}
              borderRadius="lg"
              border="1px solid"
              borderColor="blue.100"
            >
              <Icon as={FaCreditCard} color="blue.500" w={6} h={6} />
            </Flex>
            <Box>
              <Heading size="md" color="gray.800">
                Nova cobrança: Usuário Master
              </Heading>
              <Text color="gray.600">
                A partir de 02/03/2026, o acesso master passará a ter uma
                mensalidade.
              </Text>
            </Box>
          </Flex>

          <Box bg="white" p={8} borderRadius="lg" mb={4} shadow="sm">
            <Flex align="baseline" gap={1}>
              <Heading size="2xl" color="gray.900">
                R$ 99,90
              </Heading>
              <Text fontSize="xl" color="gray.500">
                /mês
              </Text>
            </Flex>
            <Text color="gray.600" mt={2}>
              Valor cobrado mensalmente do seu saldo disponível
            </Text>
          </Box>
        </Box>
      )}

      <Box
        bg="white"
        p={8}
        borderRadius="xl"
        border="1px solid"
        borderColor="gray.200"
        mb={8}
      >
        <Heading size="md" mb={6} color="gray.800">
          Telefonia e SMS com valores reduzidos
        </Heading>
        <VStack align="stretch" spacing={4}>
          <Box>
            <Flex align="start" gap={2} mb={1}>
              <Box
                minW="6px"
                h="6px"
                bg="blue.500"
                borderRadius="full"
                mt={2}
              />
              <Text color="gray.700">
                <Text as="span" fontWeight="bold">
                  Telefonia:
                </Text>{" "}
                novo valor reduzido para R$ 0,045 por lead
              </Text>
            </Flex>
            <Text fontSize="sm" color="gray.500" pl={4}>
              A cobrança será feita pelo saldo geral da carteira PowerHub. O
              serviço não será mais descontado do saldo de cashback.
            </Text>
          </Box>
          <Box>
            <Flex align="start" gap={2} mb={1}>
              <Box
                minW="6px"
                h="6px"
                bg="blue.500"
                borderRadius="full"
                mt={2}
              />
              <Text color="gray.700">
                <Text as="span" fontWeight="bold">
                  SMS:
                </Text>{" "}
                novo valor reduzido para R$ 0,085 por envio
              </Text>
            </Flex>
            <Text fontSize="sm" color="gray.500" pl={4}>
              A cobrança será feita pelo saldo geral da carteira PowerHub. O
              serviço não será mais descontado do saldo de cashback.
            </Text>
          </Box>
        </VStack>
      </Box>

      <Box
        bg="white"
        p={8}
        borderRadius="xl"
        border="1px solid"
        borderColor="gray.200"
        mb={8}
      >
        <Heading size="md" mb={6} color="gray.800">
          Outras atualizações
        </Heading>
        <VStack align="stretch" spacing={4}>
          {[
            ...(isColombo
              ? []
              : [
                  {
                    label: "Usuário Vendedor/Operacional:",
                    value: "R$ 9,90/mês"
                  },
                  { label: "Cashback:", value: "0,05%" },
                  {
                    label: "Teto de cashback:",
                    value:
                      "Limite de acúmulo de R$ 3.000 (ao atingir, para de acumular até consumir)"
                  }
                ]),
            //
            {
              label: "Higienização Refin:",
              value: "R$ 29,90 por fila/mês",
              sub: "Inclui 1 fila isenta (até 200 consultas/dia)"
            },
            { label: "Sessão WhatsApp:", value: "R$ 49,90 por sessão/mês" },
            { label: "White label:", value: "R$ 99,90/mês" },
            { label: "Higienização de telefone:", value: "R$ 0,045 por lead" },
            { label: "Geração de mailing:", value: "R$ 0,005 por lead" },
            { label: "Consulta Offline:", value: "R$ 0,005 por lead" }
          ].map((item, index) => (
            <Flex key={index} align="start" gap={2}>
              <Box
                minW="6px"
                h="6px"
                bg="blue.500"
                borderRadius="full"
                mt={2}
              />
              <Box>
                <Text color="gray.700">
                  <Text as="span" fontWeight="bold">
                    {item.label}
                  </Text>{" "}
                  {item.value}
                </Text>
                {item.sub && (
                  <Text fontSize="sm" color="gray.500" mt={1}>
                    {item.sub}
                  </Text>
                )}
              </Box>
            </Flex>
          ))}
        </VStack>
        <Divider my={6} />
        <Flex align="start" gap={2}>
          <Box minW="6px" h="6px" bg="gray.400" borderRadius="full" mt={2} />
          <Text color="gray.700">
            <Text as="span" fontWeight="bold">
              Demais serviços:
            </Text>{" "}
            Permanecem com o preço atual
          </Text>
        </Flex>
      </Box>

      <Box
        bg="white"
        p={8}
        borderRadius="xl"
        border="1px solid"
        borderColor="gray.200"
        mb={8}
      >
        <Heading size="md" mb={6} color="gray.800">
          Como será a cobrança
        </Heading>
        <VStack align="stretch" spacing={4}>
          {[
            ...(isColombo
              ? []
              : [
                  "Usuário master: descontado automaticamente do saldo da carteira PowerHub"
                ]),
            //
            "Caso não haja saldo suficiente: você pode solicitar transferência da conta Storm ou adicionar saldo via Pix",
            "Demais serviços: via saldo da carteira PowerHub",
            "SMS e Telefonia, incluindo consulta avulsa e higienização, serão descontados do saldo geral da carteira PowerHub, conforme os valores informados. O cashback não será mais utilizado nesses serviços.",
            "O saldo geral da carteira PowerHub pode ser composto por transferência da conta Storm ou Pix."
          ].map((text, index) => (
            <Flex key={index} gap={3}>
              <Icon as={BsCheckCircle} color="blue.500" w={5} h={5} mt={0.5} />
              <Text color="gray.700">{text}</Text>
            </Flex>
          ))}
        </VStack>
      </Box>
    </>
  );
}
